<template>
  <div style="display: inline-block">
    <i
      v-if="icon.thumbnail === null"
      :class="'fa fa-fw ' + icon.icon"
      :style="
        'width:' +
        sizeInPixels +
        'px; height:' +
        sizeInPixels +
        'px; max-width: none; font-size:' +
        sizeInPixels +
        'px; color:' +
        icon.color
      "
    />
    <img
      v-if="icon.thumbnail !== null"
      :src="icon.thumbnail"
      :style="'width: ' + sizeInPixels + 'px; height: ' + sizeInPixels + 'px; max-width: none'"
      alt="Preview thumbnail"
      class="lgi-image"
      data-toggle="tooltip"
      data-placement="right"
      data-html="true"
    />
  </div>
</template>

<script>
export default {
  props: {
    icon: { type: Object, required: true },
    size: { type: String, required: false, default: 'md' },
  },
  computed: {
    sizeInPixels() {
      switch (this.size) {
        case 'sm':
          return 20
        case 'lg':
          return 80
        default:
          return 40 // md
      }
    },
  },
}
</script>

<style scoped lang="scss">
.checkbox {
  margin: 4px 0;
  @media (min-width: 768px) {
    margin: 0;
  }
}
</style>
